module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-calendar module-calendar--dates",
    on: {
      "mouseup": _vm.doneSelecting,
      "mouseleave": _vm.doneSelecting
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', [_c('action', {
    attrs: {
      "icon": "prev",
      "color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prevMonth.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.gotoToday
    }
  }, [_vm._v(_vm._s(_vm.headline))]), _vm._v(" "), _c('div', [_c('action', {
    attrs: {
      "icon": "next",
      "color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextMonth.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('table', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.mon')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.tue')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.wed')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.thu')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.fri')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.sat')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.sun')))])]), _vm._v(" "), _vm._l((_vm.calendar), function(days, week) {
    return _c('tr', _vm._l((_vm.sortDays(days)), function(day) {
      return _c('td', {
        class: _vm.getClasses(day),
        on: {
          "mousedown": function($event) {
            $event.stopPropagation();
            return _vm.select($event, day)
          },
          "mouseenter": function($event) {
            return _vm.dragSelect(day)
          }
        }
      }, [_c('span', [_vm._v(_vm._s(day.day))])])
    }), 0)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f05fed94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Dates.vue
// module id = 523
// module chunks = 225